import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
    lastUrl: null,
    updateLocation: false,
    lastRequestDate: new Date()
  },

  mutations: {
    SET_LAST_URL (state, url) {
      state.lastUrl = url
    },

    SET_UPDATE_LOCATION (state, flag) {
      state.updateLocation = flag
    },

    SET_LAST_REQUEST_DATE (state) {
      state.lastRequestDate = new Date()
    }
  },

  actions: {
    verifyTokenAndAuthorization: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/user/verifyTokenAndAuthorization', { url: data }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    setLastUrl: ({ commit }, url) => {
      return new Promise((resolve, reject) => {
        commit('SET_LAST_URL', url)
        resolve()
      })
    },

    setUpdateLocation: ({ commit }, flag) => {
      return new Promise((resolve, reject) => {
        commit('SET_UPDATE_LOCATION', flag)
        resolve()
      })
    },

    renewToken: ({ commit }) => {
      return axios.get('/user/renewToken')
    },

    setLastRequestDate: ({ commit }) => {
      commit('SET_LAST_REQUEST_DATE')
    }

  },

  getters: {
    lastUrl: state => state.lastUrl,
    updateLocation: state => state.updateLocation,
    lastRequestDate: state => state.lastRequestDate
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/token.js